import React from "react";
import "../verification/verification.scss";

const LockedPage = () => {
  const handleContactSupport = () => {
    window.open("https://esignatureguarantee.com/contact", "_blank", "noopener,noreferrer");
  };

  return (
    <section className="verification-locked">
      <div className="container">
        <div className="row" style={{ display: "flex", justifyContent: "center" }}>
          <div className="col form">
            <div className="status-error">
              <span className="status-icon fa fa-times-circle"></span>
              <h2 className="status-title">Unable to Verify Identity</h2>
              <p className="status-message">
                We're sorry, but you we were unable to verify your identity using the information provided.
              </p>
            </div>

            <div className="form-group">
              <div className="col-md-12 pad">
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={handleContactSupport}
                >
                  Contact Us
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LockedPage;
